export default "__VITE_ASSET__HnxiNIdv__"